import {HTTP_STATUS} from '../../constants/http';
import {
  CNPJ_TYPES,
  EC_REPRESENTATIVE_DATA
} from '../../constants/typesMessages';
import {overwriteMessages} from '../overwriteMessages';

const checkErrors = (errorResponse, typeData) => {
  let messagesList = [];

  if (!errorResponse.response) {
    messagesList.push({
      text: `Algo aconteceu! Por favor verifique o ${typeData} e tente novamente.`
    });
    return {messages: messagesList};
  }

  if (errorResponse.response.data.code === HTTP_STATUS.BAD_REQUEST) {
    if (errorResponse.response.data.description !== 'Erro de validação.') {
      messagesList.push({text: errorResponse.response.data.description});
    }

    let subErrors = [];
    if (errorResponse.response.data.subErrors) {
      subErrors = errorResponse.response.data.subErrors.map(
        (subErrorItem) => subErrorItem.message
      );

      if (subErrors.length > 0) {
        messagesList.push({text: subErrors.toString()});
      }
    }

    messagesList.push({text: `Por favor, digite um ${typeData} válido`});
  } else {
    messagesList.push({
      text: `Ops, algo deu errado :(`
    });
  }

  return {messages: messagesList};
};

export const showErrors = (errorResponse, typeData = 'dado') => {
  return checkErrors(errorResponse, typeData);
};

const checkTypeErrorBadRequest = (responseData, msg) => {
  let messagesList = [];
  if (responseData.description !== 'Erro de validação.') {
    let newMessages = overwriteMessages(responseData.description);
    messagesList.push(newMessages[0]);
  }

  let subErrors = [];
  if (responseData.subErrors) {
    subErrors = responseData.subErrors.map(
      (subErrorItem) => subErrorItem.message
    );

    if (subErrors.length > 0) {
      messagesList.push({text: subErrors.toString()});
    }
  }

  if (msg !== '') {
    messagesList.push({text: msg});
  }
  return messagesList;
};

const setErrorMessages = (errorResponse, msg) => {
  let allMessages = [];
  const responseData = errorResponse.response.data;
  switch (responseData.code) {
    case HTTP_STATUS.BAD_REQUEST:
      allMessages = checkTypeErrorBadRequest(responseData, msg);
      break;

    case HTTP_STATUS.ENTITY_TOO_LARGE:
      allMessages = [
        {
          text: 'Tamanho máximo de 4MB permitido foi excedido.'
        }
      ];
      break;

    case HTTP_STATUS.GATEWAY_TIMEOUT:
      allMessages = [
        {
          text: 'Tempo excedido, verifique sua conexão com a Internet.'
        }
      ];
      break;

    default:
      {
        let textError = msg !== '' ? msg : `Ops, algo deu errado :(`;
        allMessages = [
          {
            text: textError
          }
        ];
      }
      break;
  }
  return allMessages;
};

export const newCheckErrors = (errorResponse, msg = '') => {
  let messagesList = [];
  if (!errorResponse.response) {
    messagesList.push({
      text: `Ops, algo deu errado :(`
    });
    return {messages: messagesList};
  }
  messagesList = setErrorMessages(errorResponse, msg);
  return {messages: messagesList};
};

const errorCnpj = () => [
  {text: 'Ops, algo deu errado :('},
  {text: 'Por favor, preencher o CNPJ novamente.'}
];

const errorDetails = (messagesList, responseData) => {
  let messageOfErrorData = '';
  let representativeDataErrorList = [];
  let responseFlow = CNPJ_TYPES.CNPJ;
  let responseType = CNPJ_TYPES.CNPJ_FLOW;

  for (const key in responseData.subErrors) {
    let newMessages = overwriteMessages(responseData.subErrors[key].message);
    messagesList.push(newMessages[0]);
    representativeDataErrorList.push(responseData.subErrors[key].object);
  }

  if (representativeDataErrorList.indexOf('cpf') > -1) {
    messageOfErrorData = 'Por favor, preencher o CPF novamente.';
    responseType = EC_REPRESENTATIVE_DATA.FLOW;
    responseFlow = EC_REPRESENTATIVE_DATA.CPF;
  }

  if (representativeDataErrorList.indexOf('email') > -1) {
    messageOfErrorData = 'Por favor, preencher o e-mail novamente.';
    responseType = EC_REPRESENTATIVE_DATA.FLOW;
    responseFlow = EC_REPRESENTATIVE_DATA.EMAIL;
  }

  if (representativeDataErrorList.indexOf('telephoneNumber') > -1) {
    messageOfErrorData = 'Por favor, preencher o telefone novamente.';
    responseType = EC_REPRESENTATIVE_DATA.FLOW;
    responseFlow = EC_REPRESENTATIVE_DATA.PHONE;
  }

  if (representativeDataErrorList.indexOf('displayName') > -1) {
    messageOfErrorData = 'Por favor, preencher o CPF novamente.';
    responseType = EC_REPRESENTATIVE_DATA.FLOW;
    responseFlow = EC_REPRESENTATIVE_DATA.NAME;
  }

  if (messageOfErrorData !== '') {
    messagesList.push({text: messageOfErrorData});
  }

  return {
    messagesList,
    responseFlow,
    responseType
  };
};

export const checkErrorsEcDataAndCnpj = (errorResponse) => {
  let messagesList = errorCnpj();
  let responseFlow = CNPJ_TYPES.CNPJ;
  let responseType = CNPJ_TYPES.CNPJ_FLOW;

  if (errorResponse.response) {
    const responseData = errorResponse.response.data;
    if (responseData.code === HTTP_STATUS.BAD_REQUEST) {
      if (responseData.description !== 'Erro de validação.') {
        messagesList = [{text: responseData.description}];
      }

      if (responseData.subErrors && responseData.subErrors.length > 0) {
        let res = errorDetails([], responseData);
        messagesList = res.messagesList;
        responseFlow = res.responseFlow;
        responseType = res.responseType;
      }
    }
  }

  return {
    responseFlow,
    responseType,
    messages: messagesList
  };
};
